import type { IPaymentStatusResponse } from './models';
import { KEGatewayClient } from '../KEGatewayClient';
import { useAuthSDK } from '~/features/auth-sdk';

const { authSDKController } = useAuthSDK();

export class _PaymentClient extends KEGatewayClient {
  constructor() {
    super(authSDKController);
  }

  public async getPaymentState(paymentId: string) {
    return this.get<IPaymentStatusResponse>(`user/payment/sbp/${paymentId}/state`);
  }
}

export const PaymentClient = new _PaymentClient();
